import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../pages/HomePage')
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})

export default router
